import React, { useMemo } from 'react';
import { TextContainer } from '../TextContainer';
import { Text } from '../Text';
import { Skeleton } from './Skeleton';
export function SkeletonText(props) {
    const { rows = 1, paragraphs = 1, ...rest } = props;
    return (React.createElement(TextContainer, { ...rest }, useMemo(() => Array.from({ length: paragraphs }).map((_, index) => (React.createElement(Text.P, { key: index }, Array.from({ length: rows }).map((_, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement(Skeleton, { elementType: "span", size: random(75, 100), inline: true }),
        React.createElement("br", null))))))), [paragraphs, rows])));
}
function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
SkeletonText.displayName = 'Skeleton.Text';
//# sourceMappingURL=SkeletonText.js.map